import { render, staticRenderFns } from "./BallotDecision.vue?vue&type=template&id=71ea2d53&"
import script from "./BallotDecision.vue?vue&type=script&lang=js&"
export * from "./BallotDecision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports